/* eslint-disable */
export enum REGEX {
	MSISDN = 'msisdn-[0-9]{5,15}',
	IMSI = 'imsi-[0-9]{5,15}',
}
